import { Buttons } from '@components/CommonModal/components/Buttons';
import { TagsInput } from '@modules/notifications/components/SendNotificationModal/components/TagsInput/index';
import Grid from '@mui/material/Grid';
import { FastField } from 'formik';
import { create } from 'react-modal-promise';
import * as yup from 'yup';
import CommonModal from '../../../../components/CommonModal';

const ParametersTagsModal = (props) => {
  const submit = () => props.onResolve();
  const reject = () => props.onReject();

  const handleClose = () => reject();

  const formik = {
    initialValues: {
      settingsTags: props.settingsTags || [],
    },
    validationSchema: yup.object({}),
    onSubmit: (valuesForm) => {
      props.save(valuesForm.settingsTags);
      handleClose();
    },
  };

  return (
    <>
      <CommonModal
        modalOpen={props.isOpen}
        title={'Select tags'}
        formik={formik}
        isForm
        handleClose={handleClose}
        buttons={<Buttons submitTitle={'Save'} loading={props.loading} handleClose={handleClose} />}
      >
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <FastField name={'settingsTags'} label={'Tags'} component={TagsInput} />
          </Grid>
        </Grid>
      </CommonModal>
    </>
  );
};

export default create(ParametersTagsModal);
